export function authHeader(refresh = false) {
  const token = localStorage.getItem(refresh ? 'refresh_token' : 'access_token');
  if (token) {
    return { 'Authorization': 'Bearer ' + token };
  } else {
    return {};
  }
}
